module.exports = __webpack_public_path__ + "img/wf.be825203.svg";